import React, { Component } from 'react';

export default class InvoiceDetail extends Component {

  render() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              {this.props.isAlreadyFinished? <h4>Invoice Detail</h4> : <h4>Edit Items for Invoice</h4> }
              {this.props.isAlreadyFinished?
                <div className="btn btn-primary m-0" onClick={this.props.goToLabels}>
                  See Labels<i className="fa fa-check ml-05"></i>
                </div>
                :
                <div className="btn btn-primary pull-right m-0" onClick={this.props.finishInvoice}>
                  Finish<i className="fa fa-check"></i>
              </div>
              }
            </div>
            <div className="card-block">
              <div className="row">
                <div className="col-sm-4">
                  <h4>ID</h4>
                  <p>
                    {this.props.invoice? this.props.invoice.invoice_number : this.props.invoice}
                  </p>
                </div>
                <div className="col-sm-4">
                  <h4>Vendor</h4>
                  <p>
                    {this.props.invoice && this.props.invoice.vendor? this.props.invoice.vendor.name : this.props.invoice}
                  </p>

                </div>
                <div className="col-sm-4">
                  <h4>Amount</h4>
                  <p>
                    {this.props.invoice? this.props.invoice.total_amount : this.props.invoice}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
